<div class="radio--box">
  <div class="main--box {{active ? 'active' : ''}}">
    <img [src]="icon" alt="icon" />
    <div class="checked--box">
      <i class="fas fa-check"></i>
    </div>
  </div>
  <span class="detail--box">
    <span class="title">{{title}}</span>
    <span class="text d-none d-sm-block">{{description}}</span>
  </span>
</div>